var ConditionOperators = /* @__PURE__ */ ((ConditionOperators2) => {
  ConditionOperators2["equal"] = "equal";
  ConditionOperators2["notEqual"] = "notEqual";
  ConditionOperators2["notEmpty"] = "notEmpty";
  ConditionOperators2["empty"] = "empty";
  ConditionOperators2["contains"] = "contains";
  ConditionOperators2["notContains"] = "notContains";
  ConditionOperators2["greaterThanOrEqual"] = "greaterThanOrEqual";
  ConditionOperators2["greaterThan"] = "greaterThan";
  ConditionOperators2["afterOrEqual"] = "afterOrEqual";
  ConditionOperators2["after"] = "after";
  ConditionOperators2["lessThanOrEqual"] = "lessThanOrEqual";
  ConditionOperators2["lessThan"] = "lessThan";
  ConditionOperators2["beforeOrEqual"] = "beforeOrEqual";
  ConditionOperators2["before"] = "before";
  ConditionOperators2["between"] = "between";
  ConditionOperators2["any"] = "any";
  ConditionOperators2["arrayEqual"] = "arrayEqual";
  ConditionOperators2["arrayNotEqual"] = "arrayNotEqual";
  ConditionOperators2["checked"] = "checked";
  ConditionOperators2["notChecked"] = "notChecked";
  ConditionOperators2["in"] = "in";
  ConditionOperators2["notIn"] = "notIn";
  ConditionOperators2["isDateNewerThan"] = "isDateNewerThan";
  ConditionOperators2["isDateOlderThan"] = "isDateOlderThan";
  ConditionOperators2["isDateNewerThanOrEqual"] = "isDateNewerThanOrEqual";
  ConditionOperators2["isDateOlderThanOrEqual"] = "isDateOlderThanOrEqual";
  return ConditionOperators2;
})(ConditionOperators || {});
export {
  ConditionOperators
};
//# sourceMappingURL=condition-operators.js.map
